import * as angular from "angular";
import {IController} from "angular";
import {ProgramLocationType} from "../../types/program-location.type";
import {ServiceAreasServiceType} from "../../../service-areas/angular/types/service-areas-service.type";

export class ProgramLocationSelectCtrl implements IController {

  locationType: ProgramLocationType;
  locationId: string;
  excludeIds: string[];
  accountIds: string[];
  onAccountSelect: Function;
  onDepotSelect: Function;
  onCustomerSelect: Function;
  onCreateCustomer: Function;

  public locationTypes: typeof ProgramLocationType = ProgramLocationType;
  public serviceAreaServiceTypes: ServiceAreasServiceType[];

  constructor() {
    this.locationTypes = ProgramLocationType;
    this.serviceAreaServiceTypes = [ServiceAreasServiceType.Pricing]
  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

}


angular
  .module('bringoz.admin.pricePlan')
  .component('programLocationSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      locationType: '<',
      locationId: '<',
      excludeIds: '<?',
      accountIds: '<?',
      onLocationTypeChange: '&',
      onAccountSelect: '&',
      onDepotSelect: '&',
      onCustomerSelect: '&',
      onCreateCustomer: '&',
      onServiceAreaSelect: '&'
    },
    template: require('./program-location-select.html').default,
    controller: ProgramLocationSelectCtrl
  });
